document.querySelectorAll('.slideshow__slide-content-link').forEach(link => {
  link.setAttribute('target', '_self');
});


document.querySelectorAll('.thb-full-menu--link').forEach(link => {
  if (link.textContent.trim().toLowerCase() === 'deals') {
    // Style the link
    link.style.color = 'red';
    link.style.paddingLeft = '30px';
    link.style.position = 'relative'; // Required for icon positioning

    // Create the icon element
    const icon = document.createElement('img');
    icon.src = 'https://cdn.shopify.com/s/files/1/0681/7654/3930/files/icons8-quick-mode-on-48.png?v=1733947220';
    icon.style.width = '20px'; // Adjust size as needed
    icon.style.height = '20px';
    icon.style.position = 'absolute';
    icon.style.left = '5px';
    icon.style.top = '50%';
    icon.style.transform = 'translateY(-50%)';

    // Insert the icon
    link.prepend(icon);
  }
});


  document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector("#shopify-section-template--19063401054435__b6a221e5-6cbb-4160-83a7-a387a8f98553");
  if (section) {
    const h3 = section.querySelector("h3.h1");
    if (h3) {
      const h1 = document.createElement("h1");
      h1.className = h3.className;
      h1.innerHTML = h3.innerHTML; 
      h3.parentNode.replaceChild(h1, h3);
    }
  }
});
